import React from "react";

export const SortAndroid = ({ fill = "#FA53A4" }) => (
  <svg fill="none" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
    <mask height="20" id="sortArray" maskUnits="userSpaceOnUse" width="20" x="0" y="0">
      <path d="M0 0h20v20H0z" fill="#D9D9D9" />
    </mask>
    <g mask="url(#sortArray)">
      <path d="M3 14.5V13h5v1.5H3Zm0-3.75v-1.5h9v1.5H3ZM3 7V5.5h14V7H3Z" fill={fill} />
    </g>
  </svg>
);
